function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default getParameterByName;

export const convertToFloat = (num) => {
  try {
    if (num == undefined || num == "") return parseFloat(0);
    else return parseFloat(num.toString().replaceAll(",", ""));
  } catch (err) {
    return parseFloat(0);
  }
};

export const getBankName = (bankDetails , bankId) => {
  const bank = bankDetails?.find((item) => item?.["bank_Id"] === bankId);
  return bank?.["bank_Name"];
};
